import { render } from "./ListeCertificats.vue?vue&type=template&id=1808e8d8&scoped=true&ts=true"
import script from "./ListeCertificats.vue?vue&type=script&lang=ts"
export * from "./ListeCertificats.vue?vue&type=script&lang=ts"

import "./ListeCertificats.vue?vue&type=style&index=0&id=1808e8d8&scoped=true&lang=css"

import exportComponent from "/workspaces/theokoel.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1808e8d8"]])

export default __exports__